<template>
  <div class="row" style="margin-right:0px;height:100%;">
    <div class="col-sm-12" style="padding-right:0px;height:100%;">
      <div style="height:100%;" id="fullscreenHolder">
        <v-btn
            color="grey"
            fixed
            outline
            small
            fab
            @click="toggleFullscreen"
            style="z-index:100000000; right:10px;top:5px"
        >
          <v-icon
              v-if="fullscreen"
              dark
          >
            mdi-fullscreen-exit
          </v-icon>
          <v-icon
              v-if="!fullscreen"
              dark
          >
            mdi-fullscreen
          </v-icon>
        </v-btn>
        <div
            v-if="img"
            style="position:fixed;left:12px;bottom:10px;"
        >
          <img
              :src="img"
              style="width:20%;height:auto;"
              alt="The image"
          >
        </div>
        <v-btn
            color="success"
            fixed
            dark
            fab
            icon
            large
            @click="onCapture"
            :loading="!cameraButtonActive"
            style="z-index:1000000000;left:50%;bottom:10px;transform: translate(-50%, 0);"
        >
          <v-icon dark>mdi-camera</v-icon>
        </v-btn>
        <v-btn
            color="blue"
            fixed
            fab
            icon
            @click="close"
            style="z-index:1000000000;left:5px;top:5px;"
        >
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
            color="blue"
            fixed
            fab
            icon
            large
            dark
            @click="settings"
            style="z-index:1000000000;right:5px;bottom:10px;"
        >
          <v-icon dark>mdi-alert-circle-outline</v-icon>
        </v-btn>
        <vue-web-cam
            :device-id="deviceId"
            :resolution="resolution"
            ref="webcam"
            width="100%"
            height="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
            style="max-height:100%;max-width:100%;"
        />
      </div>
    </div>
    <v-dialog v-model="settingsDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>Innstillinger</h3>
        </v-card-title>
        <v-card-text>
          <h4>Velg kamera</h4>
          <v-select
              :items="devices"
              v-model="camera"
              item-key="deviceId"
              item-value="deviceId"
              item-text="label"
          />
        </v-card-text>
        <v-card-actions>
          <button type="button" class="btn btn-primary" @click="settingsDialog=false">Lukk innstillinger</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {WebCam} from "vue-web-cam";
import {upload} from "./file-upload.service";
import ImageHolder from "../../models/image";

export default {
  name: "App",
  components: {
    "vue-web-cam": WebCam
  },
  data() {
    return {
      img: null,
      camera: null,
      cameraMessage: null,
      deviceId: null,
      devices: [],
      cameraButtonActive: true,
      resolution: {
        width: 4290,
        height: 2800
      },
      fullscreen: false,
      settingsDialog: false
    };
  },
  mounted: function () {
    this.$nextTick(() => {
      document.addEventListener("fullscreenchange", () => {
        this.fullscreen = !this.fullscreen
      });
      window.addEventListener("orientationchange", () => {
        this.handleOrientationChange()
      });
    })
  },
  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      const [first] = this.devices;
      const listCopy = [...this.devices]
      if (this.deviceId === null) {
        for (let dev in listCopy.reverse()) {
          if (/bak|Bak|back|Back/.test(this.devices[dev].label)) {
            this.camera = this.devices[dev].deviceId;
          }
        }
      }
      if (first && this.camera === null) {
        this.camera = first.deviceId;
      }
    }
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.cameraButtonActive = false;

      /*this.playSound(
        "https://soundbible.com/mp3/Camera%20Click-SoundBible.com-44806439.mp3"
      );*/

      const cameraButtonActiveID = setTimeout(() => {
        this.cameraButtonActive = true
        clearTimeout(cameraButtonActiveID)
      }, 700);

      const cameraMessageStartID = setTimeout(() => {
        this.cameraMessage = "Bilde lagret!"
        clearTimeout(cameraMessageStartID)
      }, 700);

      const cameraMessageEndID = setTimeout(() => {
        this.cameraMessage = null
        clearTimeout(cameraMessageEndID)
      }, 1500);

      this.filesChange(this.img);
    },
    onStarted(stream) {
    },
    onStopped(stream) {
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
    },
    save(formData, photo) {
      // upload data to the server
      //this.currentStatus = STATUS_SAVING;
      this.alert = false;

      upload(this.$route.params.protocolHash, formData)
          .then(x => {
            photo.public_id = x.public_id;
            photo.base64 = null;
            this.$emit("image-updated", photo);
            //this.currentStatus = STATUS_INITIAL;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.alert = true;
            //this.currentStatus = STATUS_FAILED;
          });
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type: mime});
    },
    filesChange(img) {
      // handle file changes
      let photo = new ImageHolder();
      const formData = new FormData();

      this.resizeBase64Img(img, 70, 39).then((result) => {
        photo.base64 = result;
        this.$emit("new-image", photo);
      });

      let file = this.dataURLtoFile(img, "image.jpg");
      let fileList = [];
      fileList.push(file);

      let reader = new FileReader();
      Array.from(Array(fileList.length).keys()).map(x => {
        reader.readAsDataURL(fileList[x]);
        formData.append("photo", fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, photo);
    },
    playSound(sound) {
      if (sound) {
        let audio = new Audio(sound);
        audio.play();
      }
    },
    toggleFullscreen() {
      let elem = document.getElementById("fullscreenHolder");
      if (this.fullscreen) {
        this.closeFullscreen(elem)
      } else {
        this.openFullscreen(elem)
      }
    },
    openFullscreen(elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen(elem) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    close() {
      if (this.fullscreen) {
        let elem = document.getElementById("fullscreenHolder");
        this.closeFullscreen(elem)
      }
      this.$emit('close')
    },
    settings() {
      if (this.fullscreen) {
        let elem = document.getElementById("fullscreenHolder");
        this.closeFullscreen(elem)
      }
      this.settingsDialog = true
    },
    handleOrientationChange() {
      if (this.img) {
        this.$emit('close-and-open')
      }
    },
    resizeBase64Img(base64, newWidth, newHeight) {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement("canvas");
        canvas.style.width = newWidth.toString() + "px";
        canvas.style.height = newHeight.toString() + "px";
        let context = canvas.getContext("2d");
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
          context.scale(newWidth / img.width, newHeight / img.height);
          context.drawImage(img, 0, 0);
          resolve(canvas.toDataURL());
        }
      });
    }
  }
};
</script>

